define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("registration-templates/buy-now/buyNowConfirmation.tmpl");
    var Button = require("ui/button/Button");
    var BuyNowConfirmationView = {};
    var InputField = require("ui/input-field/InputField");
    var Checkbox = require("ui/checkbox/Checkbox");
    var Loader = require("ui/loader/Loader");
    var Bubble = require("ui/bubble/Bubble");
    var GeneralUtilities = require("infra-util/GeneralUtilities");
    var Link = require("ui/link/Link");
    var StepIndicator = require("ui/stepIndicator/StepIndicator");


    LE.module('LERegistration', function (LERegistration, LE, Backbone, Marionette, $, _) {

        var that;

        BuyNowConfirmationView = Marionette.ItemView.extend({

            className: 'buy-now-confirmation-container',

            template: template,

            withUIComponents: true,

            initialize: function (options) {
                LERegistration.logger.info("buyNowConfirmationView >> initialize >> START");
                that = this;
                this.model = options.model;
                this.isPaying= this.model.get("creditCardRef") === undefined;
                this.model.set("firstTimePayment", !this.isPaying);
                this.flowType= options.flowType;
                this.listenTo(this, "page:closeButtonClick", _onClosePage);

                this.model.set("termDisclaimer", options.term);
                LERegistration.logger.info("buyNowConfirmationView >> initialize >> END");
            },

            ui: {
                name: ".name H4",
                emailAddress: ".email-address H4",
                website: ".website H4",
                creditCardDetails: ".credit-card-details H4",
                address: ".address H4",
                zip: ".zip H4",
                phone: ".phone H4",
                email: ".email H4",
                paymentPeriod: ".payment-period H3",
                paymentPlanLabel: ".payment-plan-label H4",
                paymentPlan: ".payment-plan",
                paymentPlanDiscountPanel: ".payment-plan-discount-panel",
                paymentPlanDiscountLabelFirst: ".payment-plan-discount-label-first H4",
                paymentPlanDiscountLabelSecond: ".payment-plan-discount-label-second H4",
                paymentPlanDiscount: ".payment-plan-discount",
                additionalEngagement: ".additional-engagement H6",
                totalPayment: ".total-payment H1",
                totalPaymentLabel: ".total-payment-label",
                youSavedPanel: ".you-saved-panel",
                youSavedLabel: ".you-saved-label H4",
                youSaved: ".you-saved",
                infoEdit: ".info-panel .edit",
                checkoutEdit: ".checkout-panel .edit",
                termsConditionsCheckbox: ".terms-conditions-checkbox",
                termsConditionsLink: ".terms-conditions",
                confirmButton: ".confirm-button",
                cancelButton: ".cancel-button",
                legalIcon: ".legal-icon",
                hiddenCcRef: ".hidden-ccref",
                stepIndicator: ".step-indicator"
            },

            uiComponents: {

                infoEdit: {
                    type: Button,
                    options: {
                        el: "view.ui.infoEdit",
                        permutation:Button.PERMUTATION.BLUELINK,
                        onClick : infoEdit
                    }
                },
                checkoutEdit: {
                    type: Button,
                    options: {
                        el: "view.ui.checkoutEdit",
                        permutation:Button.PERMUTATION.BLUELINK,
                        onClick : checkoutEdit
                    }
                },
                termsConditions: {
                    type: Link,
                    options: {
                        el:"view.ui.termsConditionsLink",
                        href : "http://www.liveperson.com/policies/license-agreement",
                        text: LE.translator.translate("LERegistration.LicenseAgreement"),
                        tabindex: -1
                    }
                },

                confirmButton: {
                    type: Button,
                    options: {
                        el: "view.ui.confirmButton",
                        permutation:Button.PERMUTATION.BTN_PRIMARY,
                        initState:Button.STATES.DISABLED,
                        tabindex: 0
                    },
                    events: {
                        "click": confirm
                    }
                },
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK,
                        initState: Button.STATES.ENABLED
                    },
                    events: {
                        "click": _onClosePage
                    }
                },
                stepIndicator: {
                    type: StepIndicator,
                    options: "stepIndicatorOptions"
                }
            },

            events: {
                'keypress input': 'keyPressEnter',
                'mouseover .legal-icon': 'showLegalBubble',
                'mouseleave .legal-icon': 'hideLegalBubble'
            },


            showLegalBubble: function () {
                LERegistration.logger.info("buyNowConfirmationView >> showLegalBubble >> START");
                var legalText= LE.translator.translate("LERegistration.Confirmation.legal.text");
                legalText= legalText.replace("{0}", this.model.get("additionalEngagementValue"));
                showLegalBubbleText(this.ui.legalIcon, Bubble.POSITION.TOP, LE.translator.translate("LERegistration.Confirmation.legal.title"),legalText, "legalIcon");
                LERegistration.logger.info("buyNowConfirmationView >> showLegalBubble >> END");
            },
            hideLegalBubble: function () {
                LERegistration.logger.info("buyNowConfirmationView >> hideLegalBubble >> START");
                hideLegalBubbleText("legalIcon");
                LERegistration.logger.info("buyNowConfirmationView >> hideLegalBubble >> END");
            },

            onRender: function () {
                LERegistration.logger.info("buyNowConfirmationView >> onRender >> START");
                this.ui.name.text(this.model.get("crmDetails.firstName") + " " + this.model.get("crmDetails.lastName"));
                this.ui.website.text(this.model.get("crmDetails.website"));
                this.ui.emailAddress.text(this.model.get("crmDetails.email"));

                this.ui.creditCardDetails.text(this.model.get("creditCardDetails.creditCardType") + " " +
                    " **** " + "**** " + "**** " + this.model.get("creditCardDetails.creditCardMaskNumber").substr(-4,4) + " " +
                    this.model.get("creditCardDetails.creditCardExpirationMonth") + "/" +
                    this.model.get("creditCardDetails.creditCardExpirationYear"));
                this.ui.address.text(this.model.get("creditCardDetails.creditCardAddress1") + " " + this.model.get("creditCardDetails.creditCardCity"));
                if (this.model.get("creditCardDetails.creditCardState")!==null ) {
                    this.ui.zip.text(this.model.get("creditCardDetails.creditCardState")  + " " + this.model.get("creditCardDetails.creditCardPostalCode"));
                }
                else {
                    this.ui.zip.text(this.model.get("creditCardDetails.creditCardPostalCode"));
                }
                this.ui.phone.text(this.model.get("creditCardDetails.phone"));
                this.ui.email.text(this.model.get("creditCardDetails.email"));
                switch(this.model.get("pendingPlan.baseBillingFrequencyMonths")) {
                    case 1:
                        this.ui.paymentPeriod.text(LE.translator.translate("LERegistration.Confirmation.monthly.payment"));
                        this.ui.totalPaymentLabel.text(LE.translator.translate("LERegistration.Confirmation.total.payment")+" / mo");
                        //this.ui.totalPaymentLabel.text(LE.translator.translate("LERegistration.Confirmation.monthly.total.payment"));
                        break;
                    case 3:
                        this.ui.paymentPeriod.text(LE.translator.translate("LERegistration.Confirmation.quarterly.payment"));
                        break;
                    case 12:
                        this.ui.paymentPeriod.text(LE.translator.translate("LERegistration.Confirmation.annual.payment"));
                        break;
                    case 36:
                        this.ui.paymentPeriod.text(LE.translator.translate("LERegistration.Confirmation.three.years.payment"));
                        break;
                    default:
                    //TODO Something went wrong
                }

                var isDiscountPercentage = false;
                if(this.model.get("pendingPlan.ratePlanCharges." + this.model.get("currency") +".discountPercentage")) {
                    isDiscountPercentage = true;
                }
                this.ui.paymentPlanLabel.text(this.model.get("pendingPlan.includedUnits") + " " + this.ui.paymentPlanLabel.text());
                var paymentPlanValue = this.model.get("pendingPlan.ratePlanCharges." + this.model.get("currency") + ".flatFeePrice")/this.model.get("pendingPlan.baseBillingFrequencyMonths");
                if(!LE.utilities.validation.isInteger(paymentPlanValue)) {
                    paymentPlanValue = GeneralUtilities.preciseRound(paymentPlanValue, 2);
                }
                this.ui.paymentPlan.text("$" + paymentPlanValue + "/mo");
                if(isDiscountPercentage) {
                    this.ui.paymentPlanDiscountLabelFirst.text(this.model.get("pendingPlan.ratePlanCharges." + this.model.get("currency") + ".discountPercentage") +
                        "% " + this.ui.paymentPlanDiscountLabelFirst.text());
                    var paymentPlanDiscountValue = (this.model.get("pendingPlan.ratePlanCharges." + this.model.get("currency") +".flatFeePrice") * (100-this.model.get("pendingPlan.ratePlanCharges." + this.model.get("currency") +".discountPercentage"))/100)/this.model.get("pendingPlan.baseBillingFrequencyMonths");
                    if(!LE.utilities.validation.isInteger(paymentPlanDiscountValue)) {
                        paymentPlanDiscountValue = GeneralUtilities.preciseRound(paymentPlanDiscountValue, 2);
                    }
                    this.ui.paymentPlanDiscount.text("$" + paymentPlanDiscountValue + "/mo");
                } else {
                    this.ui.paymentPlanDiscountPanel.hide();
                }
                var additionalEngagementValue =  this.model.get("pendingPlan.ratePlanCharges." + this.model.get("currency") +".overageUnitPrice");
                if(!LE.utilities.validation.isInteger(additionalEngagementValue)) {
                    additionalEngagementValue = GeneralUtilities.preciseRound(additionalEngagementValue, 2);
                }
                this.model.set("additionalEngagementValue", additionalEngagementValue);

                this.ui.additionalEngagement.text("$" + additionalEngagementValue + " " + this.ui.additionalEngagement.text());

                var totalPayment = this.model.get("pendingPlan.ratePlanCharges." + this.model.get("currency") +".flatFeePrice");
                if(isDiscountPercentage) {
                    //var totalPaymentValue = this.model.get("pendingPlan.ratePlanCharges." + this.model.get("currency") +".flatFeePrice") * ((100 - this.model.get("pendingPlan.ratePlanCharges." + this.model.get("currency") +".discountPercentage"))/100);
                    var totalPaymentValue = this.model.get("pendingPlan.ratePlanCharges." + this.model.get("currency") +".flatFeePrice") - this.model.get("pendingPlan.ratePlanCharges." + this.model.get("currency") +".discountPrice");
                    if(!LE.utilities.validation.isInteger(totalPaymentValue)) {
                        totalPaymentValue = GeneralUtilities.preciseRound(totalPaymentValue, 2);
                    }
                    totalPayment = totalPaymentValue;
                    this.totalPayment = totalPayment;
                }
                this.ui.totalPayment.text("$" + totalPayment);
                if(isDiscountPercentage) {
//                    var youSaveValue = this.model.get("pendingPlan.ratePlanCharges." + this.model.get("currency") +".flatFeePrice") - totalPayment;
                    var youSaveValue = this.model.get("pendingPlan.ratePlanCharges." + this.model.get("currency") +".discountPrice");
                    if(!LE.utilities.validation.isInteger(youSaveValue)) {
                        youSaveValue = GeneralUtilities.preciseRound(youSaveValue, 2);
                    }
                    this.ui.youSavedLabel.text(this.ui.youSavedLabel.text() + " $" + youSaveValue);
                    this.ui.youSaved.text("$" + this.model.get("pendingPlan.ratePlanCharges." + this.model.get("currency") +".flatFeePrice"));
                } else {
                    this.ui.youSavedPanel.hide();
                }

                this.chkBox = new Checkbox({
                    checked:false,
                    label:'',
                    permutation: Checkbox.PERMUTATION.B,
                    el:this.ui.termsConditionsCheckbox
                });
                this.chkBox.render();
                this.listenTo(this.chkBox, Checkbox.TRIGGERING.CHANGE, termsConditionsCheckbox);
                if(!(LE.sessionManager && LE.sessionManager.getAccountId())) {
                    this.uiComponents.cancelButton.hide();
                }

                this.ui.hiddenCcRef.text(this.model.get('creditCardRef'));

                LERegistration.logger.info("buyNowConfirmationView >> onRender >> END");
            },

            stepIndicatorOptions: function(){
                var hasPersonal= this.model.get("hasPersonal");
                var step= this.flowType === "changePlan" ? (hasPersonal ? "01":"0") : "1";
                var steps= [
                    { text: LE.translator.translate("LERegistration.BuyNow.stepIndicator.step" + step), state: StepIndicator.STATE.COMPLETED},
                    { text: LE.translator.translate("LERegistration.BuyNow.stepIndicator.step2"), state: StepIndicator.STATE.COMPLETED},
                    { text: LE.translator.translate("LERegistration.BuyNow.stepIndicator.step3"), state: StepIndicator.STATE.CURRENT}
                ];

                if(this.isPaying){
                    //ommit middle step
                    steps.splice(1,1);
                }

                return {
                    el: "view.ui.stepIndicator",
                    steps:  steps
                };
            }

        });

        function confirm() {
            //console.log("HEY U Purchased!!!!!!"); 
            //return;
            that.trigger(BuyNowConfirmationView.TRIGGERING.CONFIRM_BUTTON_CLICKED);
        }

        function infoEdit() {

        }

        function checkoutEdit() {

        }

        function termsConditionsCheckbox() {
            that.uiComponents.confirmButton.setEnabled(that.chkBox.isChecked());
        }

        function hideLegalBubbleText(id){
            LERegistration.logger.info("buyNowConfirmationView >> hideLegalBubbleText >> START");
            if (that.uiComponents.hasOwnProperty(id)){
                that.uiComponents[id].close();
            }
            LERegistration.logger.info("buyNowConfirmationView >> hideLegalBubbleText >> END");
        }

        function showLegalBubbleText(el, position,title, text, id) {
            LERegistration.logger.info("buyNowConfirmationView >> showLegalBubbleText >> START");
            var op = {
                targetControl:el,
                title: title,
                text: text,
                position: position,
                showCloseButton: false,
                permutation: Bubble.PERMUTATION.F
            };
            op.isDelayed = true;
            that.uiComponents.host$.createAndRender(id, {
                type: Bubble,
                options: op

            });

            LERegistration.logger.info("buyNowConfirmationView >> showLegalBubbleText >> END");
        }

        function _onClosePage() {
            LERegistration.logger.info("buyNowConfirmationView >> _onClosePage");
            that.trigger(BuyNowConfirmationView.TRIGGERING.CANCEL_BUTTON_CLICKED);

        }
    });

    BuyNowConfirmationView.TRIGGERING = {
        CONFIRM_BUTTON_CLICKED: "confirm",
        CANCEL_BUTTON_CLICKED: "cancel"
    };

    return BuyNowConfirmationView;
});


